import React, { useEffect, useRef, useState } from 'react';
import downArrow from '../../../assets/images/down-arrow.svg';

export const DomainSingleSelect: React.FC<{
  label?: string;
  domains: { id: number; name: string }[];
  selectedId: number | null;
  onChange: (id: number | null) => void;
  placeholder?: string;
  displayFormat?: 'nameOnly' | 'nameWithId';
}> = ({ label, domains, selectedId, onChange, placeholder = 'All domains', displayFormat = 'nameWithId' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (!containerRef.current?.contains(e.target as Node)) setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const selected = domains.find((d) => d.id === selectedId);
  const formatDomain = (d: { id: number; name: string }) =>
    displayFormat === 'nameWithId' ? `${d.name} (#${d.id})` : d.name;
  const buttonLabel = selected ? formatDomain(selected) : placeholder;

  return (
    <div className="flex flex-col gap-1" ref={containerRef}>
      {label && <label className="text-xs font-semibold uppercase tracking-wide text-gray-500">{label}</label>}
      <div className="relative">
        <button
          type="button"
          className="focus:ring-blue-primary flex w-full items-center justify-between rounded-md border border-gray-300 px-3 py-2 text-left text-sm text-gray-700 focus:outline-none focus:ring-2"
          onClick={() => setIsOpen((p) => !p)}
          aria-haspopup="listbox"
          aria-expanded={isOpen}
        >
          <span className="truncate">{buttonLabel}</span>
          <img src={downArrow} alt="" className={`ml-2 h-2 w-2 transform transition ${isOpen ? '' : 'rotate-180'}`} />
        </button>
        {isOpen && (
          <div className="absolute z-10 mt-1 w-full overflow-hidden rounded-md border border-gray-200 bg-white shadow-lg">
            <div className="max-h-60 overflow-y-auto">
              <button
                type="button"
                className={`flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-gray-50 ${
                  selectedId === null ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
                }`}
                onClick={() => {
                  onChange(null);
                  setIsOpen(false);
                }}
              >
                {placeholder}
              </button>
              {domains.map((d) => (
                <button
                  key={d.id}
                  type="button"
                  className={`flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-gray-50 ${
                    selectedId === d.id ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
                  }`}
                  onClick={() => {
                    onChange(selectedId === d.id ? null : d.id);
                    setIsOpen(false);
                  }}
                >
                  {formatDomain(d)}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
